module.exports = __webpack_public_path__ + "static/media/logo.495b8f14.png";